module.exports = __webpack_public_path__ + "img/icons8-shutdown-128.87a41902.png";